import { render, staticRenderFns } from "./CopyFile.vue?vue&type=template&id=5870e41f&scoped=true"
import script from "./CopyFile.vue?vue&type=script&lang=js"
export * from "./CopyFile.vue?vue&type=script&lang=js"
import style0 from "./CopyFile.vue?vue&type=style&index=0&id=5870e41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870e41f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VSnackbar,VSpacer,VTextField})
